import React, { useState, useEffect } from 'react';
import Popup from "reactjs-popup";
import "../../styles/Doctor-ui/Doctor-appointment/DA-notes.css";
import { API_DETAILS } from '../../App';
import axios from 'axios';
import { FaPlus, FaEdit, FaTrash } from 'react-icons/fa'; // Import edit and delete icons
import {Link} from "react-router-dom"
import { sanitizeHtml } from '../../utils/sanitizeHtml';
import { clickable } from '../../utils/a11y';

const Notes = (props) => {
  const [notes, setNotes] = useState([]);
  const [showSeverity, setShowSeverity] = useState(false);
  const [severityDescription, setSeverityDescription] = useState("");
  const [diagName, setDiagName] = useState("");
  const [symptomScore, setSymptomScore] = useState(0);

  useEffect(() => {
    fetchNotes();
  }, [props.noteSubmitted]);

  useEffect(() => {
    notes.forEach((note, i) => {
      const element = document.getElementById(`notes-${i}`);
      if (element) {
        let content = note.notes;
        if (content.startsWith('<p>Intake Form')) {
          content = content.replace('<p>Intake Form', '<p>');
        }
        // Notes can carry a patient's own intake answers; never render them raw.
        element.innerHTML = sanitizeHtml(content);
        element.style.whiteSpace = 'pre-line';
      }
    });
  }, [notes]);

  const getScoreColor = (score) => {
    if (score <= 25) return "#FF0000"; // Red for severe
    if (score <= 50) return "#FFA500"; // Orange for moderate
    if (score <= 75) return "#FFFF00"; // Yellow for mild
    return "#008000"; // Green for very mild
  };

  const getSeverityDescription = (score) => {
    if (score <= 25) {
      return (
        <>
          <h2>Severely Bothersome Symptoms</h2>
          <p style={{ fontSize: "20px" }}>
            Your symptoms are likely significantly interfering with your ability to perform activities such as
            sleeping, socializing, working, or running errands. They may be causing substantial distress and
            affecting your overall well-being.
          </p>
        </>
      );
    }
    if (score <= 50) {
      return (
        <>
          <h2>Very Bothersome Symptoms</h2>
          <p style={{ fontSize: "20px" }}>
            Your symptoms likely have a large impact on your ability to carry out daily activities such as sleeping,
            socializing, working, or running errands. They may be causing considerable discomfort and affecting your
            overall well-being.
          </p>
        </>
      );
    }
    if (score <= 75) {
      return (
        <>
          <h2>Moderately Bothersome Symptoms</h2>
          <p style={{ fontSize: "20px" }}>
            Your symptoms are likely causing notable disruption in your daily life. You are able to perform daily
            activities such as sleeping, socializing, working, or running errands, but with some difficulty or
            discomfort.
          </p>
        </>
      );
    }
    return (
      <>
        <h2>Mildly Bothersome Symptoms</h2>
        <p style={{ fontSize: "20px" }}>
          Your symptoms are likely causing some level of discomfort and inconvenience, but they are not significantly
          impacting your daily life. You may be aware of the symptoms but they are generally tolerable and do not
          impact your ability to accomplish daily tasks such as sleeping, socializing, working, or running errands.
        </p>
      </>
    );
  };

  const handleScoreClick = (score, diagnosisName) => {
    setSymptomScore(score);
    setDiagName(diagnosisName);
    setSeverityDescription(getSeverityDescription(score));
    setShowSeverity(true);
  };

  const handleClick = () => {
    props.showEditor(true);
    props.setNotes("");
  };

  const handleEdit = async (noteId) => {
    const noteToEdit = notes.find(note => note.id === noteId);
    props.setNotes(noteToEdit.notes);
    // Implement edit functionality here
    props.setNoteId(noteId);
    props.showEditor(true);
    props.setEditNote(true);
  };

  const handleDelete =  (noteId) => {
    props.setNoteId(noteId);
    props.setDeleteNote(true);

  };

  const fetchNotes = async () => {
    const url = API_DETAILS.baseUrl + API_DETAILS.PORT + `/youro/api/v1/getNotes/${props.patId}`;
    try {
      const res = await axios.get(url);
      // console.log("!!!!!!!!!notes data", res.data);
      setNotes(res.data);
    } catch (err) {
    }
  };

  return (
    <div>
      <div className='notes-doctor'>
        <div style={{ color: 'var(--youro-sky)', alignSelf: 'flex-end', cursor: 'pointer' }} onClick={handleClick}>
          <FaPlus />
          Add Notes
        </div>
        {notes && notes.length ? (
          notes.map((note, i) => (
            <div key={i} className='notes-date'>
              <div className='date' style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h3>{new Date(note.lastUpdated).toLocaleString()}, {note.doctorName || (note.notes?.startsWith("<p>Intake Form") ? "Intake Form" : note.diagName)}</h3>
                <div className="note-actions" style={{ display: 'flex', alignItems: 'center', gap: '12px' }} >
                  <FaEdit
                    className="edit-icon"
                    title="Edit"
                    style={{ fontSize: '24px', cursor: 'pointer' }}
                    onClick={() => handleEdit(note.id)} />
                  {note.docId != null && note.docId != 0 && (
                    <FaTrash
                      className="delete-icon"
                      title="Delete"
                      style={{ fontSize: '24px', cursor: note.docId ? 'pointer' : 'not-allowed' }}
                      onClick={() => handleDelete(note.id)} />
                  )}
                </div>
              </div>
              <div className='description'>
                <div className="note-content" id={`notes-${i}`} />
                {note.apptId && note.apptId !== 0 ? (
                    <Link style={{ textDecoration: 'none' }} to={`${note.apptId}`} state={{ diagId: note.diagId }} >
                      View/edit the care plan
                    </Link>
                ) : (
                    <Link style={{ textDecoration: 'none' }} to="#" onClick={(e) => e.preventDefault()} >
                      No Corresponding Appointment
                    </Link>
                )}
                {note.symptomScore && note.symptomScore !== 0 ? (
                    <p onClick={() => handleScoreClick(note.symptomScore, note.diagName)} style={{ color: 'var(--youro-sky)', cursor: 'pointer' }}>Symptom score: {note.symptomScore}</p>
                ) : (
                    <p style={{ color: 'var(--youro-sky)' }}>Symptom score: No symptom score available</p>
                )}
              </div>
            </div>
          ))
          ) : (
          <div style={{ width: '100%', height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <h3><i>No record of notes</i></h3>
          </div>
        )}
      </div>

      <Popup
        open={showSeverity}
        modal
        closeOnDocumentClick={false}
        onClose={() => {
          setShowSeverity(false);
        }}
        className="symptom-popup"
      >
        <div
          style={{
            position: "absolute",
            top: "20px",
            right: "20px",
            cursor: "pointer",
          }}
          {...clickable(() => {
            setShowSeverity(false);
          }, "Close")}
        >
          <span className="material-symbols-outlined">close</span>
        </div>

        <div style={{ padding: "30px 50px" }}>
          <br />
          <div style={{ textAlign: "start", fontSize: "18px", marginTop: "10px" }}>
            <div style={{ textAlign: "center"}}>
              <p>Diagnosis Name: <strong> { diagName } </strong></p>
              <h2>Your Symptom Score</h2>
              <br></br>
              <div
                style={{
                  width: "100px",
                  height: "100px",
                  borderRadius: "50%",
                  backgroundColor: getScoreColor(symptomScore),
                  color: "#000",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: "24px",
                  fontWeight: "bold",
                  margin: "0 auto", // This centers the circle horizontally
                  position: "relative",
                }}
              >
                {symptomScore}
              </div>
              {severityDescription && (
                <div style={{ marginTop: "10px" }}>
                  {severityDescription}
                </div>
              )}
            </div>
          </div>
        </div>
      </Popup>
    </div>
  );
};

export default Notes;
